import { css } from 'glamor';
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Link from '../Link/Link';
import './Notification.css';

class NotificationContainer extends Component {
  render() {
    return (
      <ToastContainer
        progressClassName={css({
          height: "1px"
        })}
      />
    )
  }
}

class Notification extends Component {
  componentDidMount() {
    this.props.onRef(this)
  }
  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  show() {
    console.log('showing')
    toast.info("Info Notification !", {
      position: toast.POSITION.BOTTOM_CENTER
    })
  }

  render() {
    return (
      <div>notification</div>
    );
  }
}

export default {
  Notification,
  NotificationContainer,
  show: (options) => {
    options = { ...options }
    options.type = options.type ? toast.TYPE[options.type.toUpperCase()] : toast.TYPE.INFO
    toast(options.title || 'Notification', {
      type: options.type,
      autoClose: options.delay || 50000,
      position: options.position || 'bottom-left',
      hideProgressBar: true,
      closeButton: (<Link variant="body2" color={options.type === toast.TYPE.ERROR ? 'secondary' : 'primary'}>close</Link>),
      content: 'Thank you',
      className: css({
        background: options.type === toast.TYPE.INFO ? 'rgb(0,0,0,.8) !important' : null,
        color: options.type === toast.TYPE.INFO ? 'white !important' : null
      })
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/Notification/Notification.js